import { ScopedError } from "@mirage-web/utils/scoped";

export class DelegatedError extends Error {
  name = "DelegatedError";
  constructor(public originalError: Error) {
    super(originalError.message);
  }
}

export function isDelegatedError(error: unknown): error is DelegatedError {
  if (error instanceof DelegatedError) {
    return true;
  }

  if (error instanceof ScopedError && error.cause) {
    return isDelegatedError(error.cause);
  }

  return false;
}
